import { createAsyncThunk } from '@reduxjs/toolkit'
import PurchasedItem from './purchased-item-model'
import {
  delete_purchasedItem,
  load_purchasedItems,
  store_purchasedItem,
} from './purchasedItem-service'

export const LoadPurchasedItemsAsync = createAsyncThunk<any, any>(
  'composer/load/purchasedItem',
  async (params: { uid: string }) => {
    return await load_purchasedItems(params)
  },
)

export const CreatePurchasedItemAsync = createAsyncThunk<any, any>(
  'composer/create/purchasedItem',
  async (params: PurchasedItem) => {
    return await store_purchasedItem(params)
  },
)

export const DeletePurchasedItemAsync = createAsyncThunk<any, any>(
  'composer/delete/purchasedItem',
  async (params) => {
    return await delete_purchasedItem(params)
  },
)
